export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7555.92201ef3.jpg";